// modules/DateRangeField.jsx
import React from "react";
import { Box, TextField, Grid, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DateRangeField = ({ module, value, isEditable, fieldKey, onChange }) => {
  const dateRange = value || { startDate: null, endDate: null };
  const startDayjs = dateRange.startDate ? dayjs(dateRange.startDate) : null;
  const endDayjs = dateRange.endDate ? dayjs(dateRange.endDate) : null;

  return (
    <Box marginY={2}>
      <Typography variant="h6">{module.label}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            label="Start Date"
            value={startDayjs}
            onChange={(newValue) =>
              onChange(
                fieldKey,
                "startDate",
                newValue ? newValue.toISOString() : null,
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                required={module.required}
                InputProps={{ readOnly: !isEditable }}
              />
            )}
            disabled={!isEditable}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            label="End Date"
            value={endDayjs}
            onChange={(newValue) =>
              onChange(
                fieldKey,
                "endDate",
                newValue ? newValue.toISOString() : null,
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                required={module.required}
                InputProps={{ readOnly: !isEditable }}
              />
            )}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DateRangeField;
